/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listWidgetTemplates} from '../api'

export const useMutationListWidgetTemplates = createReactQueryMutationHook('listWidgetTemplates', listWidgetTemplates)
